import { render, staticRenderFns } from "./OrderListPage.vue?vue&type=template&id=6e0dd7a0&"
import script from "./OrderListPage.vue?vue&type=script&lang=js&"
export * from "./OrderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports